import { getStatusQueryString } from '@quromedical/fhir-common';
import type { AdmissionGetResponseWithMedia } from '@quromedical/models';
import { AdmissionApi } from 'integration/aggregate';
import { useCallback } from 'react';
import useSWR from 'swr';

const api = new AdmissionApi();

type ActiveAdmissionStatuses = 'in-progress' | 'planned' | 'onleave';

export const usePatientActiveAdmission = (
  patientId: string,
  statuses: ActiveAdmissionStatuses[] = ['in-progress'],
): AdmissionGetResponseWithMedia | undefined => {
  const fetcher = useCallback(
    () =>
      api.getAdmissions({
        patient: patientId,
        status: getStatusQueryString(statuses),
        count: 3,
        sort: '-period.start',
      }),
    [patientId, statuses],
  );

  const { data } = useSWR(
    `patient-active-admissions/${patientId}-${statuses.join(',')}`,
    fetcher,
  );

  return data?.admissions?.find((a) =>
    statuses.includes(a.status as ActiveAdmissionStatuses),
  );
};
